var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "reporting-metric-toggle",
      class: { "reporting-metric-toggle--selected": _vm.selected },
      style: `border-color: ${_vm.selected ? _vm.parameter.color : ""}`
    },
    [
      _c("div", { staticClass: "title m-b-0" }, [
        _vm._v("\n    " + _vm._s(_vm.parameter.title) + "\n  ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }